import React, { useEffect, useState } from 'react';
import AsDropdown from '../../generic/adserve-react-components/AsDropdown/AsDropdown';

export const networkType = {
    ALL: 0,
    NETWORK: 1,
    SUBNETWORK: 2,
    STATION: 3
};

const LogSelection = ({
    selectedStations = [],
    id = 'logSelection',
    inputStyle,
    labelStyle,
    containerStyle,
    name,
    onApply,
    onChange,
    title,
    stations,
    height,
    readOnly
}) => {
    const [localSelectedStations, setlocalSelectedStations] = useState([]);

    const [selectionText, setSelectionText] = useState(window.translate('Select...'));
    const [networkList, setNetworkList] = useState([]);

    useEffect(() => {
        setNetworkList(stations);
    }, [stations]);

    useEffect(() => {
        updateSelectionText();
        setlocalSelectedStations(selectedStations);
    }, [selectedStations]);

    const handleTick = (selectedEntry) => {
        if (localSelectedStations.find((s) => s.id == selectedEntry.id)) {
            const mutar = localSelectedStations.filter((s) => s.id !== selectedEntry.id);
            setlocalSelectedStations(mutar);
        } else {
            const mutar = [...localSelectedStations, selectedEntry];
            setlocalSelectedStations(mutar);
        }
    };

    const updateSelectionText = () => {
        if (!selectedStations?.length) return setSelectionText(window.translate('Select...'));

        if (selectedStations.length === 1) {
            setSelectionText(selectedStations[0].name);
        } else {
            const allStations = stations?.length === selectedStations.length;

            if (allStations) {
                setSelectionText('All');
            } else {
                setSelectionText(`Multiple (${selectedStations.length} stations)`);
            }
        }

        return stations;
    };

    const handleApply = () => {
        if (onApply) {
            onApply(localSelectedStations);
        }
    };

    return (
        <>
            <AsDropdown
                id={id}
                activeValues={localSelectedStations}
                onChange={onChange}
                onApply={handleApply}
                onTick={handleTick}
                value={selectionText}
                values={networkList ? networkList : []}
                maxVisibleLength={557}
                title={title}
                name={name}
                inputStyle={inputStyle}
                labelStyle={labelStyle}
                containerStyle={containerStyle}
                tongueStyle={{ zIndex: 250, marginTop: 0, width: '229px' }}
                height={height}
                disabled={readOnly}
            />
        </>
    );
};

export default LogSelection;
